<template>
    <div>
        <div class="text-center text-danger my-2" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
             <strong>Chargement des données…</strong>
        </div>
        <div v-else>
            <h1 v-if="form.id">Édition d'une passerelle</h1>
            <h1 v-else>Ajout d'une passerelle</h1>
            <b-row class="justify-content-center">
                <b-col cols=" 12" md="6">
                    <b-form @submit.prevent.stop="onSubmit" ref="form">
                        <input type="hidden" name="id" :value="form.id" v-if="!!id"/>
                        <b-alert variant="danger" :show="errors.length > 0">
                            <p class="mb-0" v-for="error in errors" v-bind:key="error">{{error}}</p>
                        </b-alert>
                        <b-form-group label="Numéro de série" description="Numéro de la forme REP-4G.X123456789Y figurant sur l'étiquette présente sur la carte" label-for="serial">
                            <b-form-input id="serial" type="text" v-model="form.serial" required :disabled="!!id"/>
                        </b-form-group>
                        <b-form-group label="Code d'appairage" description="Séquence de 10 caractères alphanumériques figurant sur l'étiquette présente sur la carte" label-for="peeringCode">
                            <b-form-input id="peeringCode" type="text" v-model="form.peeringCode" required :disabled="!!id"/>
                        </b-form-group>
                        <b-form-group label="Intitulé" description="Intitulé de la passerelle dans les différents listings" label-for="label">
                            <b-form-input id="label" type="text" v-model="form.label" required/>
                        </b-form-group>
                        <div class="text-center">
                            <b-button type="submit" variant="primary" :disabled="processing" v-if="!!id">Valider</b-button>
                            <b-button type="submit" variant="primary" :disabled="processing" v-else>Ajouter</b-button>
                        </div>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {API_URL} from "../../variables";

    export default {
        name: "GatewayForm",
        props: ["id"],
        data() {
            return {
                form: {
                    id: null,
                    serial: "",
                    peeringCode: "",
                    label: ""
                },
                errors: [],
                loading: true,
                processing: false
            };
        },
        mounted() {
            this.form.id = this.id;
            if (this.form.id) {
                axios
                    .get(API_URL + "/user/gateway/info", {params: {id: this.form.id}})
                    .then(response => this.form = response.data)
                    .finally(() => this.loading = false);
            } else {
                this.loading = false;
            }
        },
        methods: {
            onSubmit() {
                this.processing = true;
                this.errors = [];
                axios
                    .post(API_URL + (this.form.id ? "/user/gateway/update" : "/user/gateway/register"), this.form)
                    .then(response => {
                        if (response.data.success) {
                            this.$router.push("/gateways");
                        } else {
                            this.errors.push(response.data.error);
                        }
                    })
                    .catch(() => {
                        this.errors.push("Une erreur est survenue durant le traitement de votre requête, veuillez réessayer ultérieurement");
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>